"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMultiLoanProductConcentration = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const formatMultiLoanProductConcentration = ({ borrowingBaseReportId, concentrationLimitCalculations, multiLoanProductConcentrationKickoutMap, timestamp, }) => {
    const concentrationLimitMultiLoanProductCalculations = [];
    // Setting up map to help connect each MLP concentration to its respective DB aggregate counterpart (FK).
    // Recall that "concentration_limit_calculations" also houses MLP concentration, but in aggregate view.
    const propertyKeyToCalculationMap = new Map(concentrationLimitCalculations.map((record) => [
        record.concentrationLimitKey,
        record.id, // Database ID
    ]));
    for (const kickoutMapEntry of multiLoanProductConcentrationKickoutMap.entries()) {
        const [concentrationLimitKey, lpToKickoutMap] = kickoutMapEntry;
        const concentrationLimitCalculationId = propertyKeyToCalculationMap.get(concentrationLimitKey);
        (0, common_1.finleyAssert)(concentrationLimitCalculationId, `Concentration limit calculation ID not found for concentration limit ${concentrationLimitKey}`);
        for (const [loanProductId, kickout,] of lpToKickoutMap.kickoutsByLoanProductId.entries()) {
            concentrationLimitMultiLoanProductCalculations.push({
                id: (0, uuid_1.v4)(),
                borrowingBaseReportId,
                concentrationLimitCalculationId,
                loanProductId,
                concentrationLimitKey,
                borrowingBaseReduction: kickout,
                created_at: timestamp,
                updated_at: timestamp,
            });
        }
    }
    return concentrationLimitMultiLoanProductCalculations;
};
exports.formatMultiLoanProductConcentration = formatMultiLoanProductConcentration;
//# sourceMappingURL=multiLoanProductConcentration.js.map